import React, { useEffect } from 'react';
import { Center, Stack } from '@fiverr-private/layout_components';
import { Heading, Typography, Text } from '@fiverr-private/typography';
import { globalMixpanelReporter } from '../../../events/mixpanel';
import { globalBigQueryReporter } from '../../../events/bigQuery';
import { globalGrafanaReporter } from '../../../events/grafana';
import { useSocialSigningHandlers } from '../../SocialSigningForm';
import { translate } from '../../../utils/translate';
import { FacebookButton } from '../../FacebookButton';

interface SocialFallbackStepProps {
    onProfileSetupStep(): void;
    onSocialFallbackStep(): void;
    onInitialStep(): void;
}

export const SocialFallbackStep: React.FC<SocialFallbackStepProps> = ({
    onInitialStep,
    onProfileSetupStep,
    onSocialFallbackStep,
}) => {
    const { onSuccess, onError } = useSocialSigningHandlers({
        onProfileSetup: onProfileSetupStep,
        onSocialFallback: onSocialFallbackStep,
    });

    useEffect(() => {
        globalGrafanaReporter.count('identification.%{platform}.social_provider_fallback.show');
        globalMixpanelReporter.send('Identification - Social Provider Fallback - Show');
        globalBigQueryReporter.send('identification.social_provider_fallback.show');
    }, []);

    const handleClick = () => {
        globalGrafanaReporter.count('identification.%{platform}.social_provider_fallback.another_way_click');
        globalMixpanelReporter.send('Identification - Social Provider Fallback - Another Way Click');
        globalBigQueryReporter.send('identification.social_provider_fallback.another_way_click');
        onInitialStep();
    };

    return (
        <>
            <Stack
                marginTop={{
                    default: '10',
                    sm: '0',
                }}
                direction="column"
                paddingBottom="10"
                paddingX="0"
                gap="2"
            >
                <Heading
                    size={{
                        default: 'h_xl',
                        sm: 'h_xxl',
                        md: 'h_md',
                    }}
                    fontWeight="bold"
                >
                    {translate('steps.social_fallback.title')}
                </Heading>
                <Text>{translate('steps.social_fallback.subtitle')}</Text>
            </Stack>
            <Stack direction="column">
                <Center direction="column" gap="4">
                    <FacebookButton onSuccess={onSuccess} onError={onError}>
                        {translate('social.continue_with_facebook')}
                    </FacebookButton>
                    <Typography color="grey_700" size="b_xs" fontWeight="bold" style={{ textTransform: 'uppercase' }}>
                        {translate('social.or')}
                    </Typography>
                    <Typography
                        onClick={handleClick}
                        cursor="pointer"
                        decoration="underline"
                        size="b_sm"
                        fontWeight="bold"
                    >
                        {translate('steps.social_fallback.continue_another_way')}
                    </Typography>
                </Center>
            </Stack>
        </>
    );
};
